/*
 * @Author: Src
 * @Date: 2025-05-16 17:04:01
 * @LastEditTime: 2026-09-15 09:28:26
 * @LastEditors: Src
 * @FilePath: /work-station/src/router/downloadRoutes.ts
 * @Description: 头部注释配置模板
 */
import { RouteConfig } from 'vue-router';
import Main from '@/views/Main.vue';
import Download from '@/views/download/indx.vue';
import { AuthEnum } from '@/services/permission.service';
import uploadComment from '@/views/download/uploadComment.vue';

const downloadRoutes: RouteConfig = {
  name: 'download',
  path: '/download',
  component: Main,
  meta: {
    title: '数据下载',
  },
  redirect: {
    name: 'download.index',
  },
  children: [
    {
      name: 'download.index',
      path: '/download/index',
      component: Download,
      props: {
        auth: [AuthEnum.报表下载],
      },
      meta: {
        title: '数据下载',
      },
    },
    {
      name: 'download.uploadComment',
      path: '/download/uploadComment',
      component: uploadComment,
      props: {
        auth: [AuthEnum.门店上传评论明细],
      },
      meta: {
        title: '上传评论明细',
      },
    },
  ],
};

export default downloadRoutes;
